import { alpha } from '@mui/material'

export const blackToTransparentGradient = (
  direction: 'top' | 'bottom' | 'left' | 'top',
) => `linear-gradient(
    to ${direction},
    ${alpha('#000000', 0.75)} 0%,
    ${alpha('#000000', 0)} 100%
  )`
